
export const resetPasswordConfig = {
  entityName: 'ResetPasswordRequests',
  password: 'COMMON.PASSWORD',
  confirmPassword: 'FORM_FIELD.CONFIRM_PASSWORD'
};

export const sendForgotPasswordEmail = {
  entityName: 'ADMINISTRATOR.USER.TITLE',
};

export const resetUserPassword = {
  entityName: 'ResetUserPassword',
};